import React from 'react';

import { isDefined } from '@nfctron/nexus-core';

import { useInterval } from '@mantine/hooks';

/**
 * Hook that returns the current date
 * @returns {Date}
 */
export const useNow = (updateInterval?: number) => {
	const [now, setNow] = React.useState(new Date());

	/** update date value based on provided `updateInterval` prop */
	React.useEffect(() => {
		if (isDefined(updateInterval)) {
			const interval = setInterval(() => {
				setNow(new Date());
			}, updateInterval);

			return () => clearInterval(interval);
		}
	}, [updateInterval]);

	return now;
};

/**
 * Hook that returns current date in a state with interval update
 * @returns {any}
 */
export const useNowState = (
	options: { interval: number; autoStart: boolean } = {
		interval: 60,
		autoStart: true,
	},
) => {
	const [now, setNow] = React.useState(() => new Date());

	/** update interval each minute */
	const interval = useInterval(() => {
		setNow(new Date());
	}, options.interval * 1000);

	/** handle interval control */
	React.useEffect(() => {
		if (options.autoStart) interval.start();
		else interval.stop();

		return () => {
			interval.stop();
		};
	}, [interval, options.autoStart]);

	return now;
};
